import { jsx as _jsx } from "react/jsx-runtime";
import { BreadcrumbsBase } from '@/shared/components';
import { useLocation } from 'react-router-dom';
import { CrossDockOrLocationChip } from './CrossDockOrLocationChip';
const Breadcrumbs = (props) => {
    const { pathname } = useLocation();
    const crossDockOrLocation = pathname.startsWith('/crossdock/') || pathname.startsWith('/location/');
    // Insert a chip with active crossdock or location name right after the first 'Home' icon.
    return _jsx(BreadcrumbsBase, { ...props, additionalElement: crossDockOrLocation ? _jsx(CrossDockOrLocationChip, {}) : undefined });
};
export { Breadcrumbs };
